<div class="verify-email-container">
    <div class="verify-email-card">
        <!-- Header: mismo patrón que password-update / login -->
        <div class="login-header">
            <div class="logo-wrapper">
                <img src="assets/logos/logo.png" alt="Logo" class="logo" />
            </div>
            <h1 class="welcome-title">
                {{ success ? "¡Correo verificado!" : "Verifica tu correo" }}
            </h1>
            <p class="welcome-subtitle">
                <ng-container *ngIf="success">
                    Todo listo, tu cuenta ya está confirmada
                </ng-container>
                <ng-container *ngIf="!success && mode === 'code'">
                    Escribe el código de {{ codeLength }} dígitos que te enviamos
                </ng-container>
                <ng-container *ngIf="!success && mode === 'link'">
                    Estamos confirmando tu correo electrónico
                </ng-container>
            </p>
        </div>

        <div class="form-content">
            <!-- ESTADO: verificando (modo link al cargar, o envío del código) -->
            <div *ngIf="loading || (verifying && !success)" class="state-block">
                <p-progressSpinner
                    styleClass="custom-spinner"
                    [style]="{ width: '46px', height: '46px' }"
                    strokeWidth="4"
                    animationDuration=".8s"
                ></p-progressSpinner>
                <p class="state-title">Verificando tu correo</p>
                <p class="state-text">Esto toma solo un momento...</p>
            </div>

            <!-- ESTADO: éxito + loader de redirección -->
            <div *ngIf="success" class="state-block success">
                <div class="success-badge">
                    <i class="pi pi-check"></i>
                </div>
                <p class="state-title">Tu correo quedó verificado</p>
                <p class="state-text">
                    Te llevamos al inicio de sesión en
                    <strong>{{ redirectSeconds }}</strong>
                    {{ redirectSeconds === 1 ? "segundo" : "segundos" }}
                </p>
                <div class="redirect-bar">
                    <span
                        class="redirect-bar__fill"
                        [style.animation-duration]="redirectSeconds + 's'"
                    ></span>
                </div>
                <a class="option-link" (click)="goToLogin()">
                    Ir ahora al inicio de sesión
                    <i class="pi pi-arrow-right ml-2"></i>
                </a>
            </div>

            <!-- MODO CÓDIGO -->
            <div *ngIf="!loading && !success && mode === 'code' && !verifying" class="form-wrapper">
                <!-- Correo: solo se pide si el login no lo pasó -->
                <div class="form-field mb-4" *ngIf="!email">
                    <label for="verify-email-input" class="field-label">Correo electrónico</label>
                    <div class="input-wrapper">
                        <i class="pi pi-envelope input-icon"></i>
                        <input
                            id="verify-email-input"
                            type="email"
                            pInputText
                            class="custom-input"
                            autocomplete="email"
                            placeholder="tu.correo@empresa.com"
                            [(ngModel)]="email"
                        />
                    </div>
                </div>

                <div class="email-chip" *ngIf="email">
                    <i class="pi pi-envelope"></i>
                    <span>{{ email }}</span>
                </div>

                <!-- Casillas del código -->
                <div class="form-field">
                    <label class="field-label" for="code-box-0">Código de verificación</label>
                    <div class="code-boxes" (paste)="onDigitPaste($event)">
                        <input
                            *ngFor="let i of boxes"
                            #codeBox
                            [id]="'code-box-' + i"
                            class="code-box"
                            [class.filled]="digits[i]"
                            [class.invalid]="!!error"
                            type="text"
                            inputmode="numeric"
                            maxlength="1"
                            [attr.autocomplete]="i === 0 ? 'one-time-code' : 'off'"
                            [value]="digits[i]"
                            (input)="onDigitInput(i, $event)"
                            (keydown)="onDigitKeyDown(i, $event)"
                        />
                    </div>
                    <small *ngIf="error" class="error-message">{{ error }}</small>
                    <small *ngIf="!error" class="hint-message">
                        Revisa tu bandeja de entrada. El código vence en unos minutos.
                    </small>
                </div>

                <button
                    pButton
                    pRipple
                    type="button"
                    label="Verificar mi correo"
                    icon="pi pi-check"
                    class="custom-primary-button"
                    [disabled]="!canSubmitCode"
                    (click)="submitCode()"
                ></button>

                <button
                    pButton
                    pRipple
                    type="button"
                    class="custom-secondary-button"
                    [icon]="resending ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'"
                    [label]="
                        resendCooldown > 0
                            ? 'Reenviar código en ' + resendCooldown + ' s'
                            : 'Reenviar código'
                    "
                    [disabled]="resendCooldown > 0 || resending || !email"
                    (click)="resendCode()"
                ></button>

                <div class="form-options mt-3">
                    <a [routerLink]="['/auth/login']" class="option-link">
                        <i class="pi pi-arrow-left mr-2"></i>
                        Volver al inicio de sesión
                    </a>
                </div>
            </div>

            <!-- MODO LINK: vigencia del enlace mientras se consume -->
            <div *ngIf="!loading && !success && mode === 'link' && !error && expirationDate" class="expiration-warning">
                <app-link-expiration
                    [expirationDate]="expirationDate"
                    (expirationStatusChanged)="onExpirationStatusChanged($event)"
                >
                </app-link-expiration>
            </div>

            <!-- MODO LINK: error (vencido / usado / inválido) -->
            <div *ngIf="!loading && !success && mode === 'link' && error" class="link-error">
                <div class="error-badge">
                    <i class="pi pi-exclamation-triangle"></i>
                </div>
                <p class="state-title">No pudimos verificar el enlace</p>
                <p class="state-text">{{ error }}</p>
                <ul class="reasons">
                    <li>El enlace ya se usó</li>
                    <li>El enlace venció</li>
                    <li>El enlace no es válido</li>
                </ul>

                <button
                    pButton
                    pRipple
                    type="button"
                    label="Verificar con un código"
                    icon="pi pi-key"
                    class="custom-primary-button"
                    (click)="switchToCodeMode()"
                ></button>

                <div class="form-options mt-3">
                    <a [routerLink]="['/auth/login']" class="option-link">
                        <i class="pi pi-arrow-left mr-2"></i>
                        Volver al inicio de sesión
                    </a>
                </div>
            </div>
        </div>

        <!-- Footer de ayuda (igual que password-update) -->
        <div class="form-footer">
            <p class="help-text">
                ¿Necesitas ayuda?
                <a href="mailto:comunidad@avalanz.com">Contacta soporte</a>
            </p>
        </div>
    </div>
</div>

<p-toast key="tst" position="top-right"></p-toast>
